import { useContext } from 'react';

import { CommunityDataContext, type CommunityDataContextType } from './CommunityDataContext';

export const useCommunityData = (): CommunityDataContextType => {
  const context = useContext(CommunityDataContext);
  if (!context) {
    throw new Error('useCommunityData must be used within a CommunityDataContext.Provider');
  }
  return context;
};
